<template>
<el-card shadow="never" :body-style="{ padding: '20px' }" class="mb-4 mx-auto">
    <div class="mx-auto p-1 text-gray-600">
        <h2 class="text-2xl mb-4">FAQ</h2>
        <div class="mb-4">
            <h3 class="font-bold mb-1">What is Boyfriendtv Downloader?</h3>
            <p>
                Boyfriendtv Downloader is a free Chrome extension that allows you to download videos from Boyfriendtv for offline viewing. Save videos in high quality directly to your device.
            </p>
        </div>

        <div class="mb-4">
            <h3 class="font-bold mb-1">How does Boyfriendtv Downloader work?</h3>
            <p>
                Boyfriendtv Downloader uses a Chrome extension to detect and extract video files from Boyfriendtv pages. Simply copy the video URL, paste it into the downloader interface, and the extension will find the downloadable media.
            </p>
        </div>

        <div class="mb-4">
            <h3 class="font-bold mb-1">Do I need to create an account?</h3>
            <p>
                No account is required to use Boyfriendtv Downloader. Simply install the Chrome extension and start downloading videos immediately without any registration process.
            </p>
        </div>

        <div>
            <h3 class="font-bold mb-1">What video quality can I download?</h3>
            <p>
                You can download Boyfriendtv videos in their original quality, including HD resolutions. The downloader preserves the video quality as it was uploaded to the site.
            </p>
        </div>
    </div>
</el-card>
</template>

<script>
export default {

}
</script>

<style>

</style>
